import mobileNav from './rbata.mobileNav';
import searchBox from './rbata.searchBox';
import page from '../utils/rbata.page';
import Breakpoints from 'breakpoints-js/src/breakpoints';
import tooltip from '../utils/rbata.tooltip';

const header = {
    HEADER_HEIGHT:        undefined,
    $header:              undefined,
    $mainNavList:         undefined,
    $pageMain:            undefined,
    STYLE_ADAPT_CLASS:    'header__wrapper--adapted',
    STYLE_HOVER_CLASS:    'header__nav--hover',
    LAST_SCROLL:          0,
    SCROLL_DELTA:         220,
    SCROLL_TOP_THRESHOLD: 500,
    $cartTooltip:         undefined,
    $userTooltip:         undefined,
    cartTooltipTimer:     undefined,
    userTooltipTimer:     undefined,
    sliderObject:         undefined,

    updateHeaderHeight() {
        header.HEADER_HEIGHT = header.$header.outerHeight();
    },

    /**
     * Method used for caching selectors for later use
     */
    headerScrollControlInit: () => {
        header.$header = $('.page-header');
        header.$nav = $('.header__nav');
        header.updateHeaderHeight();
        header.$pageMain = $('.page-main');
        header.$mainNavList = header.$header
                                    .find('.page-header__main-nav-list')
                                    .filter(function () {
                                        return $(this).find('.page-header__main-nav-ground').length;
                                    });
    },

    /**
     * Has logic for scroll behavior, both visibility and styling changes are triggered in this method
     * @param evt
     */
    scrollControl: (evt) => {
        const $this = $(evt.currentTarget), nowScrollTop = $this.scrollTop();

        if (Math.abs(header.LAST_SCROLL - nowScrollTop) >= header.SCROLL_DELTA) {
            if (nowScrollTop > header.LAST_SCROLL) {
                // ACTION ON SCROLLING DOWN
                // RBATA-2822: don't hide header if menu is open
                if (!header.$nav.hasClass(header.STYLE_HOVER_CLASS)) {
                    header.$header.css({top: -header.HEADER_HEIGHT})
                }
                header.SCROLL_DELTA = 5;
                searchBox.closeAllSearchBoxes();
            } else {
                // ACTION ON SCROLLING UP
                header.$header.css({top: 0})
                header.SCROLL_DELTA = 200;
            }
            header.LAST_SCROLL = nowScrollTop;
        }
        $this.scrollTop() > header.SCROLL_TOP_THRESHOLD ? header.headerBarStyleSwitcher(false) : header.headerBarStyleSwitcher(true);
    },

    /**
     * Just and event binder, enrich this method if more event has to be added
     * @returns {*|jQuery}
     */
    bindEvent: () => {
        if (header.$header.length) {
            $(window).on('scroll', header.scrollControl);
        }

        header.$mainNavList.on('mouseenter', () => {
            if (Breakpoints.is('desktop')) {
                page.addBackdrop();
                header.showHeaderHover();
            }
        });

        header.$mainNavList.on('mouseleave', () => {
            if (Breakpoints.is('desktop')) {
                page.addBackdrop(false);
                header.showHeaderHover(false);
            }
        });

        let portrait = window.matchMedia('(orientation: portrait)');
        portrait.addEventListener('change', function (e) {
            if (e.matches) {
                $('.header__notifications').css({'height': 'auto'}).addClass('d-none');
                header.$pageMain.removeClass('top-bar--active');
                if (header.sliderObject) {
                    header.sliderObject.destroy();
                    header.sliderObject = undefined;
                }
                header.headerInfoBar();
            }
        })

        header.$header.on('click', '.voucher-apply', header.addVoucherToCart);
    },

    /**
     * It will add class that will change header colors if scrolled over SCROLL_TOP_THRESHOLD
     * @param standard
     * @returns {*}
     */
    headerBarStyleSwitcher: (standard = true) => standard ?
            header.$header.removeClass(header.STYLE_ADAPT_CLASS) : header.$header.addClass(header.STYLE_ADAPT_CLASS),

    /**
     * Should add class to sub navigation and change styling if banner is present for that level
     */
    checkBannerPresence: () => {
        $('.page-header__second-level-list-wrapper')
                .has('.page-header__banner-teaser')
                .each(function (index, wrapper) {
                    $(wrapper).addClass('has-banner')
                });
    },

    /**
     * Manipulates with class to show and hide mobile nav
     */
    attachMobileMainNavEvents: () => {
        $('.page-header__mobile-open').on('click', mobileNav.openMobileNavigation);
        $('.page-header__close').on('click', mobileNav.closeMobileNavigation);
    },

    setColorsForTopBar(css) {
        document.documentElement.style.setProperty('--top-banner-border-color', css?.backgroundColor);
    },

    headerInfoBar: () => {
        const infoBarClosed = !!sessionStorage.getItem('infoBarClosed');
        const $headerNotificationsWrapper = $('.header__notifications');
        const notificationBarSliderContainerClass = '.js-header__notification-slides';
        const $slider = $('.header__notifications-slider');
        const $notificationBars = $('.header__notification-bar');
        const $sliderNavigationLeft = $headerNotificationsWrapper.find('.header__top-banner-left');
        const $sliderNavigationRight = $headerNotificationsWrapper.find('.header__top-banner-right');
        const $closeInfobar = $('.header__info-bar-close');

        if (!infoBarClosed && $notificationBars.length >= 1) {
            const calcHighestSlide = () => {
                const allNotificationBars = $notificationBars.map((index, element) => $(element).outerHeight());
                const highestTopBanner = Math.max(...allNotificationBars);
                $headerNotificationsWrapper.height(highestTopBanner);
            }
            header.$pageMain.addClass('top-bar--active');
            $headerNotificationsWrapper.removeClass('d-none');
            calcHighestSlide();

            header.sliderObject = tns({
                container:            notificationBarSliderContainerClass,
                mode:                 'gallery',
                items:                1,
                controls:             true,
                center:               true,
                nav:                  false,
                arrowKeys:            true,
                speed:                $slider.data('slider-animation-time') ?? 500,
                autoplay:             true,
                autoplayTimeout:      $slider.data('slider-timeout') ?? 8000,
                controlsContainer:    false,
                prevButton:           $sliderNavigationLeft[0],
                nextButton:           $sliderNavigationRight[0],
                autoplayButton:       false,
                autoplayButtonOutput: false,
                lazyload:             false,
                mouseDrag:            true,
                onInit:               (slider) => {
                    const firstSlideCss = $(slider.container).find('.tns-slide-active')[0].dataset;
                    header.setColorsForTopBar(firstSlideCss)
                    $headerNotificationsWrapper.css(firstSlideCss);
                    $headerNotificationsWrapper.removeClass('d-none');
                    document.documentElement.style.setProperty('--top-banner-height', `${$headerNotificationsWrapper.outerHeight()}px`);
                    header.updateHeaderHeight();
                }
            });

            const updateTopBannerColors = (tns) => {
                const css = $(tns.container).find('.tns-slide-active')[0].dataset;
                $headerNotificationsWrapper.css(css);
                header.setColorsForTopBar(css)
            }

            header.sliderObject.events.on('indexChanged', updateTopBannerColors);

            $closeInfobar.on('click', function () {
                $headerNotificationsWrapper.addClass('d-none');
                sessionStorage.setItem('infoBarClosed', 'true');
                header.sliderObject.destroy();
                header.sliderObject = undefined;
                header.$pageMain.removeClass('top-bar--active');
            });
        }
    },

    addVoucherToCart(event) {
        const voucherCode = $(event.target).text();
        const urlForVoucher = `${window.location.pathname}/bannerVoucherToCart`;

        const handleVoucherRequest = $.post(urlForVoucher, {voucherCode: voucherCode});

        handleVoucherRequest.done(function (data) {
            const {success, message} = data;
            tooltip.voucherAddTooltip(message, success);
        });

    },

    disallowToShiftPage() {
        const disallowedPage = $('body').hasClass('page-landingPage');
        return disallowedPage && (Breakpoints.is('tablet') || Breakpoints.is('desktop'));
    },

    showHeaderHover(show = true) {
        show ? header.$nav.addClass(header.STYLE_HOVER_CLASS) : header.$nav.removeClass(header.STYLE_HOVER_CLASS);
    }
}

$(() => {
    if ($('#page-header').length) {
        header.headerScrollControlInit();
        header.headerInfoBar();
        header.bindEvent();
        header.checkBannerPresence();
        header.attachMobileMainNavEvents();
    }
});

export default header;
